var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"busie-input",attrs:{"value":_vm.value,"prepend-icon":_vm.icon,"label":_vm.label,"type":_vm.type,"disabled":_vm.disabled,"rules":_vm.rules},on:{"input":function($event){return _vm.$emit("input", $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }